import { Table, TableColumns } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import styles from './../LessonsComponents.module.scss';
import { LessonTableType } from '../TimetableVersion/Table/TimetableVersionLessonsTable';

type LessonStatsTableType = { plan: number; name: string };

type SubjectStatsProps = { lessonsData: LessonTableType[] };

export const LessonStatsTable = ({ lessonsData }: SubjectStatsProps) => {
  const { t } = useTranslation();

  const lessonInfos = lessonsData.map((l) => l.teachingLoadInfo).filter((i) => !!i);

  const stats = lessonInfos.reduce(
    (accumulator, lesson) => {
      return {
        ...accumulator,
        studentHours: (accumulator.studentHours ?? 0) + (lesson.studentHours ?? 0),
        teacherHours: (accumulator.teacherHours ?? 0) + (lesson.teacherHours ?? 0),
        teachingBlockWeeks: (accumulator.teachingBlockWeeks ?? 0) + (lesson.teachingBlockWeeks ?? 0),
        deputat: (accumulator.deputat ?? 0) + (lesson.deputat ?? 0),
      };
    },
    {
      studentHours: 0,
      teacherHours: 0,
      teachingBlockWeeks: 0,
      deputat: 0,
    },
  );

  const data: LessonStatsTableType[] = [
    { plan: stats.studentHours, name: t('subjectHours.studentHours') },
    { plan: stats.teacherHours, name: t('subjectHours.teacherHours') },
    { plan: stats.deputat, name: t('deputate.title', { count: 1 }) },
    { plan: stats.teachingBlockWeeks, name: t('epochs.epochWeeksInTimeTable') },
  ];

  const columns: TableColumns<LessonStatsTableType>[] = [
    {
      header: '',
      id: 'name',
      accessorKey: 'name',
      canExpand: true,
    },
    {
      header: t('common.plan'),
      id: 'plan',
      size: 50,
      accessorFn: (row) => {
        return row.plan?.toFixed(2);
      },
      alignment: 'right',
    },
  ];

  return (
    <Table<LessonStatsTableType>
      className={styles['lesson-stats-table']}
      showBorderRadius
      showShadow
      customHeaderHeight='var(--spacing-7)'
      customRowHeight='var(--spacing-7)'
      data={data}
      columns={columns}
    />
  );
};
